import React, { Fragment, useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDimensions,
  makeSelectDivisionWithEngagement,
  makeSelectDivisions,
  makeSelectDivisionsDrillDown,
  makeSelectGraphicBars,
  makeSelectIsLoading,
  makeSelectIsLoadingGraphicBars,
  makeSelectMeasureRangeColor,
  makeSelectMetric,
  makeSelectShowHistory,
  makeSelectSwitchMoreDimensions,
  makeSelectMeasureInfo,
  makeSelectIsEngagement,
  makeSelectIsEngagementOnly,
  makeSelectIsLoadingDivision,
  makeSelectIsLoadingDivEng,
  makeSelectIdMeasure,
} from "./selectors"
import {
  getDimensionsWatcher,
  getDivisionMeasureRangeColorWatcher,
  getDivisionWithEngagementWatcher,
  getDivisionsWatcher,
  getMeasureWatcher,
  graphicBarsWatcher,
} from "./actions"

import "./index.less"
import { Empty, Layout, Spin } from "antd"
import { Helmet } from "react-helmet"
import BlockFreemiumPageBlur from "../../../components/BlockFreemiumPageBlur"
import {
  isModuleBySlug,
  isModeInModuleBySlug,
  KEY_CHECKBOX_EXCLUDE,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
} from "../../../utils/storage"
import {
  HISTORICAL_ANALYSIS,
  RESULT_BY_DIVISION,
  DISABLE,
} from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import { debounce, get } from "lodash"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import HeaderDivision from "../../../components/HeaderDivision"
import MultiBarChart from "../../../components/MultiBarChart"
import BarChartDivisionNotHistory from "../../../components/Recharts/BarChartDivisionNotHistory"
import ResultTableByDivisionV2 from "../../../components/ResultTableByDivisionV2"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function DivisionAnalysis(props) {
  const searchLocation = getUrlParams(location.search) || {}
  const [measureID] = useState(parseInt(props.match.params.id))
  const prevMeasureID = usePreviousMeasureID(measureID)
  const [checkboxExclude, setCheckboxExclude] = useState(
    LOCAL_CHECKBOX_EXCLUDE() == "true" && LOCAL_ISOLATED_METRICS() == "true"
  )
  const [searchDivision, setSearchDivision] = useState("")
  const [selectedDimension, setSelectedDimension] = useState(null)
  const [selectedType, setSelectedType] = useState("Engagement")
  const [clearState, setClearState] = useState(false)
  const [filtersAreEmpty, setFiltersAreEmpty] = useState(true)
  const [idSegment] = useState(
    searchLocation
      ? validate.exist(searchLocation.id_segment) &&
        searchLocation.id_segment !== "undefined"
        ? searchLocation.id_segment
        : null
      : null
  )

  // 1. Para iniciar la vista se necesita /dimensions /measure /measureRangeColor

  useEffect(() => {
    initGetData()
  }, [])

  const initGetData = async () => {
    const searchLocation = getUrlParams(location.search) || {}
    
    props.getMeasureWatcher({
      idMeasure: measureID,
      idSegment,
    })
    props.getDimensions({
      measure: measureID,
      params: searchLocation,
      isExclude: checkboxExclude,
    })
    props.getMeasureRangeColorWatcher({
      measure: measureID,
    })

  }

  // 2. Cuando se obtenga la data de la medi, dependiendo si es engagement 
  // se mostrará se llamara a los endpoints de engagement o clima
  
  useEffect(() => {
    if(!validate.exist(props.idMeasure)) {
      return
    }
      
    if(props.isEngagement) {
      return getEngagementData()
    } 

    return getClimateData()
      
  }, [props.idMeasure])


  const getEngagementData = () => {
    // En caso sea una medición de engagement se llamará al endpoint /engagement 
    // solo si el filtro es tipo engagement
    loadDivisions(selectedType === 'Engagement')
    loadBars()
  }

  const getClimateData = () => {
    loadDivisions(false)
    loadBars()
  }
  

  useEffect(() => {
    
    if(filtersAreEmpty) {
      setFiltersAreEmpty(false)
      return
    }
      
    loadContent()
  }, [
    selectedDimension,
    checkboxExclude,
    selectedType,
    searchDivision,
  ])
  
  const loadContent = () => {
    let isEngagement = props.isEngagement
    if(isEngagement) {
      isEngagement = selectedType == 'Engagement'
    }
    
    loadDivisions(isEngagement)
    loadBars()
  }

  const loadBars = () => {

    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)

    let graphicBarsData = {
      switchBars: isHistoricalAnalysis ? 1 : 0,
      selectedType: selectedType,
      isExclude: checkboxExclude,
      id_segment: idSegment,
    }
    
    let graphicBarsParams = {
      id_segment: idSegment,
      isExclude: checkboxExclude,
    }

    let params = {
      idMeasure: measureID,
      isExclude: checkboxExclude,
      data: graphicBarsData,
      params: graphicBarsParams
    }

    // Verify if the graphic bars were loaded to add more parameters
    if(validate.exist(props.graphicBars.data)) {
      params = {
        ...params,
        data: {
          ...graphicBarsData,
          search: searchDivision,
          dimension: selectedDimension,
          params: searchLocation,
        }
      }
    }

    props.graphicBarsWatcher(params)
  }

  const loadDivisions = (engagementCall) => {
    let params = {
      measure: measureID,
      search: searchDivision,
      dimension: selectedDimension,
      isEngagement: props.isEngagement,
      isExclude: checkboxExclude,
      selectedType,
      params: searchLocation,
    }
    
    props.getDivisions(params)
    if(engagementCall){
      props.divisionWithEngagementWatcher(params)  
    } 
  }

  const renderHeader = () => {
    const { measureInfo, dimensions, isEngagement, isEngagementOnly } = props
    if (!validate.exist(measureInfo)) {
      return null
    }
    if (!Array.isArray(dimensions) || dimensions.length === 0) {
      return null
    }

    return (
      <HeaderDivision
        measureInfo={measureInfo}
        dimensions={dimensions}
        isEngagement={isEngagement}
        isEngagementOnly={isEngagementOnly}
        checkboxExclude={checkboxExclude}
        changeExcludeCheckbox={changeExcludeCheckbox}
        searchLocation={searchLocation}
        selectedType={selectedType}
        onChangeType={onChangeType}
        selectedDimension={selectedDimension}
        onChangeDimension={onChangeDimension}
        searchDivision={searchDivision}
        onChangeSearchDivision={onChangeSearchDivision}
        selectedSegment={idSegment}

      />
    )
  }

  const onChangeType = (value) => {
    setSelectedType(value)
    setSelectedDimension(null)
  }

  const onChangeDimension = (value) => {
    setSelectedDimension(value)
  }

  const onChangeSearchDivision = (value) => {
    setSearchDivision(value)
  }

  const changeExcludeCheckbox = (e) => {
    setItem(KEY_CHECKBOX_EXCLUDE, e.target.checked)
    setCheckboxExclude(e.target.checked)
  }

  const renderContent = () => {
    if (props.isEngagement && props.isLoadingDivEng) {
      return (
        <Fragment>
          <div className="DivisionAnalysis-Content loadingSpin">
            <Spin size="large" />
          </div>
        </Fragment>
      )
    }
    if (props.isLoadingDivision) {
      return (
        <Fragment>
          <div className="DivisionAnalysis-Content loadingSpin">
            <Spin size="large" />
          </div>
        </Fragment>
      )
    }
    if (get(props, "divisions", []).length === 0) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }
    return (
      <div className="DivisionAnalysis-Content" >
        {renderContentTop()}
        {renderContentBottom()}
      </div>
    )
  }

  const renderContentTop = () => {
    const {
      metric,
      switchMoreDimensions,
      showHistory,
      graphicBarsWatcher,
      isLoadingGraphicBars,
      graphicBars,
      divisionsDrillDown,
    } = props
    /* if (
      idSegment === null &&
      get(props.measureInfo, "segments", []).length > 0
    ) {
      return null
    } */
    return (
      <Fragment>
        {showHistory && switchMoreDimensions ? (
          <MultiBarChart
            {...graphicBars}
            resultByDivison
            selectedType={selectedType}
            match={props.match}
            calculationType={props.measureInfo.id_survey_calculation_type}
            loading={isLoadingGraphicBars}
            hasDataHistory={switchMoreDimensions}
            clearState={clearState}
            graphicBarsWatcher={graphicBarsWatcher}
            setStateFrom={() => setClearState(false)}
            clearFilters={() => {
              // setSearchDivision(undefined)
              // setSelectedDimension(undefined)
            }}
            useSingleCall
            checkboxExclude={checkboxExclude}
            idSegment={idSegment}
          />
        ) : (
          <div style={{ marginTop: "1.25rem" }} className="boxShadow">
            <BarChartDivisionNotHistory
              legendVerticalAlign="top"
              legendMargin={{
                top: 0,
                left: 15,
              }}
              metric={metric}
              divisionsDrillDown={divisionsDrillDown}
              calculationType={props.measureInfo.id_survey_calculation_type}
            />
          </div>
        )}
      </Fragment>
    )
  }

  const renderContentBottom = () => {
    const {
      measureColorRange,
      measureInfo,
      divisions,
      isEngagement,
      showHistory,
      divisionsWithEngagement,
    } = props
    let showActions = true
    let useSegments = false
    if (
      idSegment === null &&
      get(props.measureInfo, "segments", []).length > 1
    ) {
      showActions = false
    }

    if (get(props.measureInfo, "segments", []).length > 0) {
      useSegments = true
    }
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            marginBottom: "16px",
            paddingRight: "4px",
            marginTop: "8px"
          }}>
          <div style={{ width: "max-content" }}>
            <MeasurementColorRange measureColorRange={measureColorRange} />
          </div>
        </div>
        <ResultTableByDivisionV2
          data={divisions}
          dataWithEngagement={divisionsWithEngagement}
          measureInfo={measureInfo}
          isEngagement={isEngagement}
          showActions={showActions}
          selectedSegment={idSegment}
          useSegments={useSegments}
        />
      </Fragment>
    )
  }

  if (props.isLoading) {
    return (
      <Fragment>
        <div className="DivisionAnalysis loadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  const isResultByDivision = isModeInModuleBySlug(RESULT_BY_DIVISION)
  if (isResultByDivision === DISABLE) {
    return <div />
  }

  return (
    <Layout>
      <Helmet>
        <title>Reportes - Resultado por división</title>
        <meta name="description" content="Description of DivisionAnalysis" />
      </Helmet>
      <div className="DivisionAnalysis">
        <div className="DivisionAnalysis-Container">
          {renderHeader()}
          {renderContent()}
        </div>
      </div>
      <BlockFreemiumPageBlur view="engagement-result-division" />
    </Layout>
  )
}

DivisionAnalysis.propTypes = {
  dimensions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoading: PropTypes.bool,
  metric: PropTypes.object,
  isLoadingMeditions: PropTypes.bool,
  showHistory: PropTypes.bool,
  switchMoreDimensions: PropTypes.bool,
  graphicBars: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoadingGraphicBars: PropTypes.bool,
  divisionsWithEngagement: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  measureColorRange: PropTypes.array,
  measureInfo: PropTypes.object,
  idMeasure: PropTypes.number,
  isEngagement: PropTypes.bool,
  isEngagementOnly: PropTypes.bool,
  isLoadingDivision: PropTypes.bool,
  isLoadingDivEng: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  dimensions: makeSelectDimensions(),
  divisions: makeSelectDivisions(),
  divisionsDrillDown: makeSelectDivisionsDrillDown(),
  isLoading: makeSelectIsLoading(),
  metric: makeSelectMetric(),
  showHistory: makeSelectShowHistory(),
  switchMoreDimensions: makeSelectSwitchMoreDimensions(),
  graphicBars: makeSelectGraphicBars(),
  isLoadingGraphicBars: makeSelectIsLoadingGraphicBars(),
  divisionsWithEngagement: makeSelectDivisionWithEngagement(),
  measureColorRange: makeSelectMeasureRangeColor(),
  measureInfo: makeSelectMeasureInfo(),
  idMeasure: makeSelectIdMeasure(),
  isEngagement: makeSelectIsEngagement(),
  isEngagementOnly: makeSelectIsEngagementOnly(),
  isLoadingDivision: makeSelectIsLoadingDivision(),
  isLoadingDivEng: makeSelectIsLoadingDivEng(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
    graphicBarsWatcher: (params) => dispatch(graphicBarsWatcher(params)),
    divisionWithEngagementWatcher: (params) =>
      dispatch(getDivisionWithEngagementWatcher(params)),
    getMeasureRangeColorWatcher: (params) =>
      dispatch(getDivisionMeasureRangeColorWatcher(params)),
    getMeasureWatcher: (params) => dispatch(getMeasureWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "divisionAnalysis", reducer })
const withSaga = injectSaga({ key: "divisionAnalysis", saga })

export default compose(withReducer, withSaga, withConnect)(DivisionAnalysis)
